import { Record } from 'immutable';

import { EditableReport, ReportFormRecordBase } from '../../common/forms/reportForm/records';

import { IReportUpdateState } from '../types';

export const ReportUpdateState = Record<IReportUpdateState>({
  modifiedReport: EditableReport,
  ...ReportFormRecordBase
});
